import * as React from 'react';
import {normalize} from '../utils/helpers';
import Color from '../theme/Color';
import Svg, {Defs, LinearGradient, Path, Stop} from 'react-native-svg';

export interface HeaderProps {
  width: number;
  height: number;
  color: string;
}

const WIDTH = 17;
const HEIGHT = 17;

export const AvatarBot = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  let strokeColor = props.color || Color.black;
  //fill="#364152"
  return (
    <Svg width={width} height={height} viewBox="0 0 16 16">
      <Path
        d="M7.668,4.886C7.668,5.446 7.214,5.9 6.654,5.9C6.095,5.9 5.641,5.446 5.641,4.886C5.641,4.327 6.095,3.873 6.654,3.873C7.214,3.873 7.668,4.327 7.668,4.886Z"
        fill={strokeColor}
      />
      <Path
        d="M9.578,5.9C10.138,5.9 10.592,5.446 10.592,4.886C10.592,4.327 10.138,3.873 9.578,3.873C9.018,3.873 8.565,4.327 8.565,4.886C8.565,5.446 9.018,5.9 9.578,5.9Z"
        fill={strokeColor}
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.616,1C8.616,0.724 8.392,0.5 8.116,0.5C7.84,0.5 7.616,0.724 7.616,1V1.463H5.758C4.362,1.463 3.231,2.594 3.231,3.99V5.783C3.231,7.179 4.362,8.31 5.758,8.31H10.475C11.871,8.31 13.002,7.179 13.002,5.783V3.99C13.002,2.594 11.871,1.463 10.475,1.463H8.616V1ZM4.231,3.99C4.231,3.146 4.915,2.463 5.758,2.463H10.475C11.318,2.463 12.002,3.146 12.002,3.99V5.783C12.002,6.626 11.318,7.31 10.475,7.31H5.758C4.915,7.31 4.231,6.626 4.231,5.783V3.99Z"
        fill={strokeColor}
      />
      <Path
        d="M4.473,10.883C4.683,10.704 4.709,10.388 4.53,10.178C4.351,9.968 4.035,9.942 3.825,10.121L2.916,10.895L2.671,11.109C2.491,11.266 2.447,11.529 2.568,11.736L2.731,12.018L3.542,13.373L3.704,13.653C3.821,13.855 4.063,13.95 4.286,13.88L4.601,13.781L5.539,13.468C5.757,13.62 5.99,13.756 6.239,13.871L6.426,14.78L6.489,15.097C6.535,15.331 6.74,15.5 6.979,15.5H9.253C9.491,15.5 9.697,15.332 9.743,15.098L9.807,14.78L9.993,13.871C10.242,13.756 10.475,13.62 10.693,13.468L11.621,13.778L11.946,13.88C12.169,13.949 12.41,13.856 12.528,13.654L12.691,13.374L13.498,12.024L13.665,11.737C13.786,11.53 13.742,11.266 13.561,11.108L13.321,10.899L12.407,10.121C12.197,9.942 11.881,9.968 11.702,10.178C11.523,10.388 11.549,10.704 11.759,10.883L12.591,11.591L11.865,12.805L10.763,12.437C10.604,12.384 10.428,12.414 10.296,12.517C10.014,12.738 9.709,12.919 9.378,13.046C9.218,13.107 9.101,13.245 9.067,13.412L8.843,14.5H7.39L7.166,13.412C7.131,13.245 7.014,13.107 6.854,13.046C6.523,12.919 6.218,12.738 5.936,12.517C5.804,12.414 5.628,12.384 5.469,12.437L4.367,12.805L3.641,11.591L4.473,10.883Z"
        fill={strokeColor}
      />
      <Path
        d="M9.659,10.101C9.914,10.207 10.035,10.5 9.929,10.755C9.634,11.464 8.934,11.964 8.116,11.964C7.302,11.964 6.604,11.467 6.307,10.762C6.2,10.508 6.32,10.215 6.574,10.107C6.829,10 7.122,10.12 7.229,10.374C7.375,10.721 7.718,10.964 8.116,10.964C8.516,10.964 8.86,10.72 9.005,10.371C9.111,10.116 9.404,9.995 9.659,10.101Z"
        fill={strokeColor}
      />
    </Svg>
  );
};

export const IcIcon_1 = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  let strokeColor = props.color || Color.black;

  return (
    <Svg width={width} height={height} viewBox="0 0 24 18">
      <Path
        fill={strokeColor}
        fill-rule="nonzero"
        d="M12.6667 7.4618V10.0965C12.0584 10.8017 11.2505 11.0427 10.4419 11.0427C9.00304 11.0427 8 9.99141 8 8.78878C8 7.56693 9.00304 6.49573 10.4419 6.49573C11.2505 6.49573 12.0584 6.74061 12.6667 7.4618Z"
      />
      <Path
        fill={strokeColor}
        fill-rule="evenodd"
        d="M21.1338 0H4.86687C4.49043 0 4.11765 0.073067 3.76982 0.215302C3.422 0.357538 3.10596 0.566062 2.83973 0.828966C2.57351 1.09187 2.36233 1.404 2.21824 1.74754C2.07416 2.09107 2 2.45928 2 2.83112V11.889C4.15213 11.8975 5.83353 13.5193 5.83353 15.5982C5.83702 16.2822 5.64868 16.9538 5.28938 17.5385H21.1338C21.8938 17.5379 22.6225 17.2394 23.1599 16.7086C23.6973 16.1778 23.9994 15.458 24 14.7073V2.83397C24.0005 2.46191 23.9267 2.09342 23.7828 1.74956C23.639 1.4057 23.428 1.09323 23.1617 0.830014C22.8955 0.5668 22.5794 0.35801 22.2315 0.215588C21.8835 0.0731658 21.5105 0 21.1338 0ZM15.3965 13.5328H12.7088V12.8055C11.9948 13.2655 11.1253 13.5328 10.0824 13.5328C7.52933 13.5328 5.46069 11.4326 5.46069 8.77776C5.46069 6.08457 7.52933 4.0014 10.0824 4.0014C11.1232 4.0014 11.9948 4.26873 12.7088 4.72873V4.0014H15.3965V13.5328ZM20.5415 13.5328H17.8538V4.0014H20.5451L20.5415 13.5328Z"
      />
      <Path
        fill={strokeColor}
        fill-rule="nonzero"
        d="M1.98691 13.6411C0.899346 13.6411 0 14.4768 0 15.5772C0 16.7028 0.899346 17.5385 1.98691 17.5385C3.10065 17.5385 4 16.7028 4 15.5772C4 14.4761 3.10065 13.6411 1.98691 13.6411Z"
      />
    </Svg>
  );
};

export const IcIcon_2 = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  let strokeColor = props.color || Color.black;

  return (
    <Svg width={width} height={height} viewBox="0 0 22 20">
      <Path
        fill={strokeColor}
        fill-rule="nonzero"
        d="M2.5 0C1.26606 0 0.25 1.01606 0.25 2.25V9.75C0.25 10.9839 1.26606 12 2.5 12H4.74414V15L8.74316 12H13C14.2339 12 15.25 10.9839 15.25 9.75V2.25C15.25 1.01606 14.2339 0 13 0H2.5ZM2.5 1.5H13C13.4191 1.5 13.75 1.83094 13.75 2.25V9.75C13.75 10.1691 13.4191 10.5 13 10.5H8.24512L6.24414 12V10.5H2.5C2.08094 10.5 1.75 10.1691 1.75 9.75V2.25C1.75 1.83094 2.08094 1.5 2.5 1.5ZM3.25 3V4.5H12.25V3H3.25ZM16.75 4.5V6H19C19.42 6 19.75 6.33 19.75 6.75V14.25C19.75 14.67 19.42 15 19 15H15.25V16.5L13.2549 15H8.5C8.185 15 7.93117 14.8214 7.82617 14.5664L6.625 15.4805C7.015 16.0955 7.705 16.5 8.5 16.5H12.7598L16.75 19.5V16.5H19C20.245 16.5 21.25 15.495 21.25 14.25V6.75C21.25 5.505 20.245 4.5 19 4.5H16.75ZM3.25 6V7.5H9.25V6H3.25Z"
      />
    </Svg>
  );
};
export const IcIcon_3 = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  let strokeColor = props.color || Color.black;

  return (
    <Svg width={width} height={height} viewBox="0 0 19 18">
      <Path
        d="M5.766,9H5.776M9.5,9H9.509M13.233,9H13.242M17.9,9C17.9,13.124 14.139,16.467 9.5,16.467C8.063,16.467 6.711,16.146 5.528,15.581L1.1,16.467L2.402,12.995C1.577,11.84 1.1,10.469 1.1,9C1.1,4.876 4.86,1.533 9.5,1.533C14.139,1.533 17.9,4.876 17.9,9Z"
        fill="none"
        stroke={strokeColor}
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
};

export const IcIcon_4 = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  let strokeColor = props.color || Color.black;

  return (
    <Svg width={width} height={height} viewBox="0 0 22 22">
      <Path
        d="M11.25,0.5C5.451,0.5 0.75,5.201 0.75,11C0.75,16.799 5.451,21.5 11.25,21.5C17.049,21.5 21.75,16.799 21.75,11C21.75,5.201 17.049,0.5 11.25,0.5ZM11.25,2.056C16.19,2.056 20.195,6.06 20.195,11C20.195,15.94 16.19,19.945 11.25,19.945C6.31,19.945 2.306,15.94 2.306,11C2.306,6.06 6.31,2.056 11.25,2.056ZM11.282,6.4C11.705,6.4 12.052,6.711 12.089,7.107L12.092,7.178V7.25C12.092,7.68 11.729,8.028 11.282,8.028C10.86,8.028 10.513,7.717 10.476,7.321L10.472,7.25V7.178C10.472,6.749 10.835,6.4 11.282,6.4ZM11.25,9.5C11.656,9.5 11.989,9.811 12.024,10.207L12.028,10.278V16.074C12.028,16.504 11.679,16.852 11.25,16.852C10.844,16.852 10.511,16.541 10.475,16.145L10.472,16.074V10.278C10.472,9.848 10.82,9.5 11.25,9.5Z"
        fill={strokeColor}
        fill-rule="evenodd"
      />
    </Svg>
  );
};

export const Koreai_logo = (props: HeaderProps) => {
  let width = props.width || normalize(WIDTH);
  let height = props.height || normalize(HEIGHT);
  //let strokeColor = props.color || Color.black;

  return (
    <Svg width={width} height={height} viewBox="0 0 41 10" fill="none">
      <Path
        d="M13.2751 5.23168C12.7964 4.75169 12.1468 4.48127 11.4689 4.47979C10.7911 4.47831 10.1403 4.74588 9.65953 5.22378C9.98131 4.90831 10.4144 4.73232 10.865 4.73392C11.3156 4.73553 11.7474 4.9146 12.0669 5.23235C12.3865 5.55011 12.568 5.98096 12.5722 6.4316C12.5763 6.88224 12.4028 7.31639 12.0893 7.64001L12.0869 7.64239L12.0754 7.65424L12.0569 7.67242C11.5772 8.15393 10.926 8.42517 10.2465 8.42647C9.56689 8.42776 8.91464 8.15901 8.4332 7.67934C7.95176 7.19966 7.68056 6.54835 7.67926 5.86869C7.67796 5.18903 7.94668 4.53669 8.42629 4.05518C7.78623 4.69453 7.42634 5.562 7.42578 6.46675C7.42523 7.3715 7.78405 8.23941 8.42332 8.87955C9.06259 9.5197 9.92994 9.87964 10.8346 9.8802C11.7392 9.88075 12.607 9.52188 13.247 8.88252C13.2514 8.87856 13.2557 8.87461 13.2597 8.87027L13.2755 8.85485L13.2806 8.84932C13.2877 8.8426 13.2944 8.83549 13.3012 8.82837L13.3103 8.81928C13.7751 8.33569 14.0318 7.68908 14.0252 7.0183C14.0186 6.34752 13.7493 5.70607 13.2751 5.23168Z"
        fill="url(#paint0_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="#17A674"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint1_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint2_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint3_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint4_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint5_linear_12409_520)"
      />
      <Path
        d="M12.4082 3.42157C11.7709 3.09462 11.0469 2.97655 10.3387 3.08408C9.63061 3.19161 8.97426 3.51929 8.46271 4.02069L8.45125 4.03215L8.43939 4.04401L8.41647 4.06693C7.93802 4.54964 7.67089 5.20268 7.67385 5.88238C7.67682 6.56208 7.94963 7.21276 8.43228 7.69128C8.91493 8.16981 9.56788 8.43697 10.2475 8.43401C10.9271 8.43104 11.5777 8.15819 12.0561 7.67548C11.7339 7.99493 11.2981 8.1735 10.8444 8.17202C10.3907 8.17053 9.95606 7.98911 9.63591 7.66756C9.31576 7.34601 9.13621 6.91057 9.13665 6.45679C9.13709 6.003 9.31748 5.56792 9.63826 5.24699L9.64893 5.23671C10.1305 4.77099 10.7753 4.51243 11.4452 4.51644C12.1151 4.52045 12.7568 4.7867 13.2328 5.25815C13.7087 5.7296 13.9812 6.36875 13.9917 7.03866C14.0022 7.70856 13.7499 8.35595 13.289 8.8421C13.6623 8.45999 13.9407 7.99557 14.1017 7.48622C14.2628 6.97687 14.3021 6.43682 14.2164 5.90952C14.1308 5.38221 13.9225 4.88239 13.6084 4.45027C13.2944 4.01815 12.8833 3.6658 12.4082 3.42157Z"
        fill="url(#paint6_linear_12409_520)"
      />
      <Path
        d="M34.372 4.19049V5.8073C34.0482 6.24002 33.6181 6.38793 33.1877 6.38793C32.4217 6.38793 31.8877 5.74278 31.8877 5.00479C31.8877 4.255 32.4217 3.59766 33.1877 3.59766C33.6181 3.59766 34.0482 3.74793 34.372 4.19049Z"
        fill="#111827"
      />
      <Path
        d="M38.9445 0.147949H30.1164C29.9121 0.147898 29.7098 0.188377 29.521 0.267076C29.3323 0.345775 29.1608 0.461151 29.0163 0.606615C28.8718 0.752079 28.7572 0.924782 28.679 1.11486C28.6008 1.30494 28.5605 1.50866 28.5605 1.71441V6.72613C29.7285 6.73085 30.641 7.62816 30.641 8.77842C30.6429 9.15686 30.5407 9.52844 30.3457 9.85196H38.9445C39.357 9.85165 39.7524 9.68651 40.0441 9.39281C40.3357 9.09911 40.4997 8.70086 40.5 8.28551V1.71598C40.5003 1.51012 40.4602 1.30624 40.3821 1.11598C40.3041 0.925722 40.1895 0.752831 40.0451 0.607195C39.9006 0.461559 39.729 0.346036 39.5402 0.267234C39.3514 0.188432 39.1489 0.147897 38.9445 0.147949ZM35.8309 7.63563H34.3723V7.2332C33.9848 7.48772 33.5129 7.63563 32.9469 7.63563C31.5613 7.63563 30.4387 6.47358 30.4387 5.00468C30.4387 3.51454 31.5613 2.36192 32.9469 2.36192C33.5117 2.36192 33.9848 2.50983 34.3723 2.76435V2.36192H35.8309V7.63563ZM38.623 7.63563H37.1644V2.36192H38.625L38.623 7.63563Z"
        fill="#111827"
      />
      <Path
        d="M4.87813 5.87122L7.49766 3.06206H5.0625L2.45742 5.88539V0.145508H0.5V9.85424H2.45742V8.44947L3.54258 7.30196L5.32969 9.85424H7.79297L4.87813 5.87122Z"
        fill="#111827"
      />
      <Path
        d="M16.8527 3.92404V3.05859H14.9258V9.85431H16.8527V5.86421C17.4082 5.25014 18.1418 4.94291 19.1813 4.90239V3.05977C18.1977 3.05977 17.4484 3.36661 16.8527 3.92404Z"
        fill="#111827"
      />
      <Path
        d="M25.9139 6.29483C25.9139 4.29997 24.5498 2.99512 22.7178 2.99512C20.6963 2.99512 19.3193 4.43569 19.3193 6.42819C19.3193 8.35577 20.7096 9.85063 22.7686 9.85063C24.2815 9.85063 25.485 9.00053 25.8322 7.76019H23.8951C23.6938 8.08407 23.3321 8.24602 22.81 8.24602C21.7943 8.24602 21.2994 7.65319 21.1525 6.89867H25.8737C25.9028 6.69877 25.9163 6.49686 25.9139 6.29483ZM21.1643 5.79484C21.3389 5.06904 21.833 4.54269 22.7291 4.54269C23.4787 4.54269 23.9608 4.988 24.067 5.79484H21.1643Z"
        fill="#111827"
      />
      <Path
        d="M28.5539 7.71143C27.9535 7.71143 27.457 8.1709 27.457 8.77592C27.457 9.39472 27.9535 9.85419 28.5539 9.85419C29.1688 9.85419 29.6652 9.39472 29.6652 8.77592C29.6652 8.17051 29.1688 7.71143 28.5539 7.71143Z"
        fill="#111827"
      />
      <Path
        d="M9.63184 5.25069L9.64009 5.24268C9.63791 5.24457 9.63586 5.24663 9.63398 5.24884L9.63184 5.25069Z"
        fill="url(#paint7_linear_12409_520)"
      />
      <Path
        d="M13.2143 8.85636L13.2182 8.85205L13.2051 8.8653L13.2143 8.85636Z"
        fill="url(#paint8_linear_12409_520)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_12409_520"
          x1="8.09462"
          y1="8.5346"
          x2="13.7939"
          y2="4.76037"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#8C8EFF" />
          <Stop offset="0.549246" stopColor="#4B4EFC" />
          <Stop offset="1" stopColor="#3D40F2" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_12409_520"
          x1="11.9113"
          y1="5.50395"
          x2="14.4807"
          y2="3.86994"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#BFC527" stopOpacity="0" />
          <Stop offset="1" stopColor="#BFC527" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_12409_520"
          x1="11.2253"
          y1="4.58099"
          x2="10.6141"
          y2="6.76368"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#FEC412" />
          <Stop offset="1" stopColor="#FEC412" stopOpacity="0" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_12409_520"
          x1="9.19214"
          y1="6.27724"
          x2="12.6347"
          y2="6.37703"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#E05063" />
          <Stop offset="1" stopColor="#E05063" stopOpacity="0" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_12409_520"
          x1="9.29193"
          y1="7.13784"
          x2="11.1004"
          y2="4.76799"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#AF348D" />
          <Stop offset="1" stopColor="#AF348D" stopOpacity="0" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_12409_520"
          x1="11.2627"
          y1="8.1107"
          x2="10.3023"
          y2="4.84288"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#3596D5" />
          <Stop offset="1" stopColor="#3596D5" stopOpacity="0" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_12409_520"
          x1="13.5827"
          y1="8.41004"
          x2="11.6744"
          y2="6.87583"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#17A674" />
          <Stop offset="1" stopColor="#17A674" stopOpacity="0" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_12409_520"
          x1="10.8559"
          y1="6.96799"
          x2="11.5368"
          y2="6.26582"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#009DAB" stopOpacity="0" />
          <Stop offset="1" stopColor="#009DAB" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_12409_520"
          x1="15.0438"
          y1="6.94979"
          x2="11.8605"
          y2="10.2201"
          gradientUnits="userSpaceOnUse">
          <Stop offset="0.24" stopColor="#009DAB" stopOpacity="0" />
          <Stop offset="1" stopColor="#009DAB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
